import {createRef, RefObject, useRef, useCallback, useState} from 'react'
import {_, useCurrentProjectState} from '../../lib'

import {selectTheme, selectMethod, selectBatchData} from '../../store'

import {AdherenceSidebar, SidebarControlRefType, AdherenceTable} from '..'

import {IGarminDevice, IParticipant, ITask, TaskType} from '../../shared/db'
import {MessagePopup, MessagePopupControlRefType} from '../molecules/message_popup'

export enum AdherenceType {
  Overview = 'overview',
  GarminDirectBbiDigest = 'garminDirectBbiDigest',
  GarminConnectWearTime = 'garminConnectWearTime',
  GCLFCombined = 'gclfCombined',
}

export enum AdherenceViewedByType {
  DeviceDataType = 'deviceDataType',
  Tasks = 'tasks',
}

export const AdherenceTableBlock = () => {
  // console.log('render AdherenceBlock') // test code
  const {color} = selectTheme()

  /* ------------------ reducer & store basic state ------------------ */
  const {projectId, project} = useCurrentProjectState()
  const batchId = project?.batchList?.[0]?.id ?? ''
  const batch = selectBatchData()?.[batchId]
  const participantList = batch?.participantList ?? []
  const method = selectMethod()
  const projectHasScheduleTask = project?.scheduleConfig ? true : false

  /* ------------------ adherence state ------------------ */

  const garminConnectEnabled: boolean = method?.garminConnectEnable
  const garminDeviceTask: ITask | undefined = _.find(method?.taskList, {type: TaskType.GarminDevice})
  const dexcomIntegrationId = method?.dexcomIntegrationId
  const taskList: ITask[] =
    method?.taskList?.filter((item) => item.type !== TaskType.GarminDevice && item.enabled) ?? []
  const garminDirectEnabled =
    (garminDeviceTask && Object.values(garminDeviceTask.garminDevice as IGarminDevice).some((c) => c)) ?? false

  const sidebarRef: RefObject<HTMLDivElement> = createRef()
  // useClickOutside(sidebarRef, () => setDisplaySidebar(false))

  const [selectedList, setSelectedList] = useState<IParticipant[]>([])

  /* ------------------ other effect ------------------ */
  const sidebarControlRef = useRef<SidebarControlRefType>(null)
  const cellClicked = useCallback(
    (participantId: string, yymmddIndex: number) => {
      if (sidebarControlRef.current) {
        sidebarControlRef.current.setSelectedCellIndex({participantId, yymmddIndex})
        sidebarControlRef.current.setDisplay(true)
      }
    },
    [sidebarControlRef.current],
  )

  const messagePopupControlRef = useRef<MessagePopupControlRefType>(null)
  const sendMessage = useCallback((participants: IParticipant[]) => {
    setSelectedList(participants)
    if (messagePopupControlRef.current) {
      messagePopupControlRef.current.setDisplayPopupSendNotification(true)
    }
  }, [])

  return (
    <>
      <AdherenceSidebar
        ref={sidebarControlRef}
        {...{
          sidebarRef,
          projectId,
          taskList,
          participantList,
          garminConnectEnabled,
          garminDirectEnabled,
          garminDeviceTask,
          projectHasScheduleTask,
          hasDexcom: !!dexcomIntegrationId,
        }}
      />

      <MessagePopup
        ref={messagePopupControlRef}
        {...{
          selectedList,
          setSelectedList,
        }}
      />

      {/* page container */}
      <div
        css={{
          width: '100%',
          height: 'calc(100vh - 106px)',
          // flex: 1,
          backgroundColor: color.background,
          padding: '30px',
          // overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          gap: '14px',
        }}>
        <AdherenceTable
          {...{
            cellClicked,
            sendMessage,
            selectedList,
            setSelectedList,
          }}
        />
      </div>
    </>
  )
}
